import { render } from "./TextAreaComponent.vue?vue&type=template&id=489390e6"
import script from "./TextAreaComponent.vue?vue&type=script&lang=js"
export * from "./TextAreaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__